// src/components/common/PageTitle.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useBranding } from '../../context/BrandingContext';

const PageTitle = () => {
  const location = useLocation();
  const { instance_name } = useBranding();

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;

    // Special cases with dynamic routes
    if (path.match(/^\/clients\/\d+$/)) return "Kundendetails";
    if (path.match(/^\/employees\/\d+$/)) return "Mitarbeiterdetails";
    if (path.match(/^\/profile/)) return "Profil";
    if (path.match(/^\/reports\/\d+$/)) return "Terminbericht";
    if (path.match(/^\/submit-report\/\d+$/)) return "Bericht erstellen";

    // Standard paths
    const pathMap = {
      '/': 'Home',
      '/calendar': 'Kalender',
      '/emails': 'E-Mails',
      '/clients': 'Kunden',
      '/admin': 'Administrationsbereich',
      '/dashboard': 'Dashboard',
      '/login': 'Anmelden',
      '/setup': 'Ersteinrichtung',
      '/office': 'Büro Dashboard',
      '/reports': 'Berichte',
      '/time-off': 'Urlaub & Abwesenheit',
      '/invoices': 'Rechnungen',
      '/work-hours': 'Arbeitszeiten',
    };

    return pathMap[path] || instance_name;
  };

  const pageTitle = getPageTitle();

  return (
    <Helmet>
      <title>{pageTitle} | {instance_name}</title>
      <meta name="description" content="Terminverwaltung für Gebärdensprachdolmetscher" />
    </Helmet>
  );
};

export default PageTitle;